import { isMessengerPath } from '@/modules/chat-matrix-fast/utils/messengerRoute'
import {
  CHAT_LIST_TAB,
  CHAT_LIST_TYPES,
  type ChatListTab,
} from '@/modules/chat-matrix-fast/constants/chat'
import { setChatDebugLane } from '@/modules/chat-matrix-fast/utils/chatDebugLog'

const SELECTED_CHAT_ID_KEY = 'selectedChatIdFast'
const CHAT_LIST_TAB_KEY = 'chatListTabFast'
const CHAT_URL_TAB_EVENTS = 'events'
const CHAT_URL_TAB_CHATS = 'chats'

export function getStoredChatListTab(): ChatListTab | null {
  try {
    const value = localStorage.getItem(CHAT_LIST_TAB_KEY)
    if (value === CHAT_LIST_TAB.EVENTS || value === CHAT_LIST_TAB.EMPLOYEES) {
      return value
    }
  } catch {
  }

  return null
}

export function setStoredChatListTab(tab: ChatListTab): void {
  try {
    localStorage.setItem(CHAT_LIST_TAB_KEY, tab)
  } catch {
  }
}

function urlTabToChatListTab(tab: unknown): ChatListTab | null {
  const value = Array.isArray(tab) ? tab[0] : tab

  if (value === CHAT_URL_TAB_EVENTS) {
    return CHAT_LIST_TAB.EVENTS
  }

  if (value === CHAT_URL_TAB_CHATS) {
    return CHAT_LIST_TAB.EMPLOYEES
  }

  return null
}

export function resolveMessengerBootChatListTab(): ChatListTab | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const url = new URL(window.location.href)
    if (!isMessengerPath(url.pathname)) {
      return null
    }

    // Только явный ?tab= из URL. Голый /messenger → обычные чаты (дефолт store),
    // а не последняя вкладка из localStorage (иначе меню кидает на ?tab=events).
    return urlTabToChatListTab(url.searchParams.get('tab'))
  } catch {
    return null
  }
}

export function applyMessengerBootChatListTab(targets?: {
  core?: { currentChatListTypes: string }
  view?: { chatListTab: ChatListTab }
}): ChatListTab | null {
  const tab = resolveMessengerBootChatListTab()
  if (!tab) {
    return null
  }

  if (targets?.core) {
    targets.core.currentChatListTypes = CHAT_LIST_TYPES[tab]
  }
  if (targets?.view) {
    targets.view.chatListTab = tab
  }

  setStoredChatListTab(tab)
  setChatDebugLane(tab === CHAT_LIST_TAB.EVENTS ? 'tasks' : 'chats')

  return tab
}

/** Сбрасывает selectedChatId; при chatId — только если совпадает с сохранённым. */
export function clearStoredSelectedChatId(chatId?: number | string | null): void {
  try {
    if (chatId == null) {
      localStorage.removeItem(SELECTED_CHAT_ID_KEY)

      return
    }

    const saved = localStorage.getItem(SELECTED_CHAT_ID_KEY)
    if (saved != null && String(saved) === String(chatId)) {
      localStorage.removeItem(SELECTED_CHAT_ID_KEY)
    }
  } catch {
  }
}
